module.exports = __webpack_public_path__ + "img/home.5cfb07de.svg";